import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class SelfPickupsAlerts {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // ******************************
  //        Public methods
  // ******************************

  // CREATE_ONE //
  createOneSuccess() {
    const message = {
      body: 'SELF_PICKUPS_CREATE_ONE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createOneError() {
    const message = {
      body: 'SELF_PICKUPS_CREATE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE_ONE //
  updateOneSuccess() {
    const message = {
      body: 'SELF_PICKUPS_UPDATE_ONE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateOneError() {
    const message = {
      body: 'SELF_PICKUPS_UPDATE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE_ONE //
  deleteOneSuccess() {
    const message = {
      body: 'SELF_PICKUPS_DELETE_ONE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteOneError() {
    const message = {
      body: 'SELF_PICKUPS_DELETE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CHANGE_STATUS //
  changeStatusSuccess() {
    const message = {
      body: 'SELF_PICKUPS_CHANGE_STATUS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  changeStatusError() {
    const message = {
      body: 'SELF_PICKUPS_CHANGE_STATUS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // SEND_MESSAGE //
  sendMessageSuccess(id) {
    const message = {
      body: 'X_SELF_PICKUPS_SEND_MESSAGE_SUCCESS'
    };
    return this.bringozToastService.success(message, {id: id})
  }

  sendMessageError(id) {
    const message = {
      body: 'X_SELF_PICKUPS_SEND_MESSAGE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message, {id: id})
  }

}

angular
  .module('bringoz.admin.self-pickups')
  .service('selfPickupsAlerts', SelfPickupsAlerts);
